import { createContext } from 'react';
import { CheckInType } from 'types/CheckInType';

export const CheckInContext = createContext<CheckInType|null>(null);
